import VerifyPhoneMediaContainer from './VerifyPhoneMediaContainer';

export default VerifyPhoneMediaContainer;
